import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { clearHighScores, getHighScores } from '../utils/localStorage';

function HighScores() {
  const [scores, setScores] = useState([]);

  useEffect(() => {
    setScores(getHighScores());
  }, []);

  const handleClear = () => {
    clearHighScores();
    setScores([]);
  };

  const formatDate = (timestamp) =>
    new Intl.DateTimeFormat(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date(timestamp));

  return (
    <section className="section score-page">
      <div className="quiz-card score-board">
        <p className="eyebrow">Top five</p>
        <h2 className="title is-3">High Scores</h2>

        {scores.length === 0 ? (
          <div className="empty-state">
            <p>No scores yet. Start a round and claim the board.</p>
          </div>
        ) : (
          <ol className="score-list">
            {scores.map((entry, index) => (
              <li key={`${entry.name}-${entry.at ?? index}`}>
                <span className="rank">{index + 1}</span>
                <div className="score-entry-main">
                  <strong>{entry.name}</strong>
                  <span>
                    {entry.category} / {entry.difficulty === 'Any' ? 'Mixed' : entry.difficulty}
                  </span>
                  <span>{entry.questions || 0} questions</span>
                </div>
                <div className="score-entry-points">
                  <strong>{entry.score}</strong>
                  <span>{formatDate(entry.at)}</span>
                </div>
              </li>
            ))}
          </ol>
        )}

        <div className="buttons is-centered mt-5">
          <Link to="/" className="button is-primary">
            Back to Start
          </Link>
          {scores.length > 0 && (
            <button className="button is-light" type="button" onClick={handleClear}>
              Clear Scores
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export default HighScores;
